export const migrateToV6 = (state)=>{
    // V6 schema just adds a new entity - no need to migrate anything.
    return state;
};

//# sourceMappingURL=v6.js.map